/**
 * Storage-Health + Reparatur für Electron-Menü (Dev + Production).
 * Single canonical API on window.__amanStorageHealth; repair alias kept for menus.
 */

import { runStorageCheck } from './storageHealthCheck';
import {
  DEFAULT_UI_REPAIR_OPTIONS,
  REINSTALL_RECOVERY_REPAIR_OPTIONS
} from './storageRepairDefaults';

export function registerStorageHealthBridge() {
  if (typeof window === 'undefined') return;

  const api = {
    runCheck: (businessId, options) => runStorageCheck(businessId, options),
    runStorageCheck: (businessId, options) => runStorageCheck(businessId, options),
    runRepair: async (options) => {
      const { runUiStorageRepair } = await import('./storageRepairPackage');
      return runUiStorageRepair({ ...DEFAULT_UI_REPAIR_OPTIONS, ...options });
    },
    runFullRepair: async (options) => {
      const { runUiStorageRepair } = await import('./storageRepairPackage');
      return runUiStorageRepair({ ...DEFAULT_UI_REPAIR_OPTIONS, ...options });
    },
    /** After reinstall / empty catalog — backup restore + relink + hydrate */
    runReinstallRecovery: async (options) => {
      const { runUiStorageRepair } = await import('./storageRepairPackage');
      return runUiStorageRepair({ ...REINSTALL_RECOVERY_REPAIR_OPTIONS, ...options });
    },
    healEmptyBusiness: async (businessId, options) => {
      const { healEmptyBusinessAfterLogin } = await import('./storageHealOrchestrator');
      // Manual / DevTools: force a fresh pass (automatic path defaults to once-per-session).
      return healEmptyBusinessAfterLogin(businessId, { force: true, ...options });
    },
    readLastRepairReport: async (businessId) => {
      const { readLastStorageRepairReport } = await import('./storageRepairPackage');
      return readLastStorageRepairReport(businessId);
    }
  };

  window.__amanStorageHealth = api;
  window.__amanStorageRepair = {
    runRepair: api.runRepair,
    runFullRepair: api.runFullRepair,
    runReinstallRecovery: api.runReinstallRecovery,
    healEmptyBusiness: api.healEmptyBusiness,
    readLastReport: api.readLastRepairReport
  };
}
